import React from 'react';

const CustomButton = ({ children, onClick, type = "button", className = "", icon, transparent, ...props }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`
                flex items-center justify-center gap-2
                px-4 py-2 rounded-[500px]
                ${transparent ? 
                    'bg-transparent text-white border-none hover:bg-[transparent] hover:underline' : 
                    'bg-[#05897e] border border-[#05897e] text-white hover:border-white'}
                
               
                body-medium
                transition-colors duration-200
                ${className}
            `}
            {...props}
        >
            {children}
            {icon || (
                <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 20 20" 
                    fill="currentColor" 
                    className="w-5 h-5"
                >
                    <path 
                        d="M3.333 10h11.666m0 0l-4.166-4.167M15 10l-4.167 4.167" 
                        stroke="currentColor" 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </button>
    );
};

export default CustomButton;
